import script from "./status-badge.vue?vue&type=script&setup=true&lang=js"
export * from "./status-badge.vue?vue&type=script&setup=true&lang=js"

import "./status-badge.vue?vue&type=style&index=0&id=ce5632f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce5632f2"]])

export default __exports__